import './App.css';
import { ThemeProvider } from './material3/components/ThemeProvider';
import Container from './material3/components/Container';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsAndConditionsPage from './pages/TermsAndConditionsPage';
import FAQPage from './pages/FAQPage';
import FeaturesPage from './pages/FeaturesPage';
import SupportPage from './pages/SupportPage';
import WhyVihanaPage from './pages/WhyVihanaPage';
import WhyPremiumPage from './pages/WhyPremiumPage';
import SafetyGuidelinesPage from './pages/SafetyGuidelinesPage';
import PurchasePolicyPage from './pages/PurchasePolicyPage';

function App() {
  return (
    <ThemeProvider>
      <Container>
        <Router>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/purchase-policy" element={<PurchasePolicyPage />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
            <Route path="/why-vihana" element={<WhyVihanaPage />} />
            <Route path="/why-premium" element={<WhyPremiumPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/safety-guidelines" element={<SafetyGuidelinesPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/features" element={<FeaturesPage />} />
            {/* Add routes for other pages */}
          </Routes>
        </Router>
      </Container>
    </ThemeProvider>
  );
}

export default App;
